import React from 'react';
import ReactDOM from 'react-dom';
import './MapsDirectionsCSS.css';
import {faChevronUp} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class MapsDirectionsComponent extends React.Component {
//src="/images/default-source/airportmaps/phxairportmap.jpg"
    constructor(props) {
        super(props);
        const isSpanish = window.location.pathname.slice(0, 4) === '/es' || window.location.pathname.slice(0, 4) === '/es/';

        this.state = {
            isSpanish,
            url: '/images/default-source/airportmaps/phxairportmap.jpg',
            t3Visible: false,
            t4Visible: false,
            parkingVisible: false,
            directionIndicator: 0,
        }
    }

    toggleVisible = (idx) => {
        switch (idx) {
            case 0:
                this.setState(Object.assign(this.state, {t3Visible: !this.state.t3Visible}));
                break;
            case 1:
                this.setState(Object.assign(this.state, {t4Visible: !this.state.t4Visible}));
                break;
            case 2:
                this.setState(Object.assign(this.state, {parkingVisible: !this.state.parkingVisible}));
                break;
            default:
                break;
        }
    };

    toggleMaps = (idx) => {
        let url = '';
        switch (idx) {
            case 0:
                url = '/images/default-source/airportmaps/phxairportmap.jpg';
                break;
            case 1:
                url = '/images/default-source/siteimages/maps/terminal2-1.jpg';
                break;
            case 2:
                url = '/images/default-source/siteimages/maps/terminal3level1-1.jpg';
                break;
            case 3:
                url = '/images/default-source/siteimages/maps/terminal3level2-1.jpg';
                break;
            case 4:
                url = '/images/default-source/siteimages/maps/terminal3level4-1.jpg';
                break;
            case 5:
                url = '/images/default-source/siteimages/maps/terminal4level1-1.jpg';
                break;
            case 6:
                url = '/images/default-source/siteimages/maps/terminal4level2-1.jpg';
                break;
            case 7:
                url = '/images/default-source/siteimages/maps/terminal4level3-1.jpg';
                break;
            case 8:
                break;
            case 9:
                break;
            case 10:
                url = '/images/default-source/siteimages/maps/fitphxtrail-2.jpg';
                break;
            default:
                break;
        }
        this.setState(Object.assign(this.state, {url}));
    };

    mapsSelector = (location) => {
        if (location === "0") return;
        if /* if we're on iOS, open in Apple Maps */
        ((navigator.platform.indexOf("iPhone") !== -1) ||
            (navigator.platform.indexOf("iPad") !== -1) ||
            (navigator.platform.indexOf("iPod") !== -1))
            this.iosSelector(location);
        else /* else use Google */
            this.otherSelector(location);
    };

    iosSelector = (location) => {
        switch (location) {
            case "1":
                window.location.href = 'maps://maps.apple.com/maps?daddr=+East+Economy,+Phoenix,+AZ+85034'
                break;
            case "3":
                window.location.href = 'maps://maps.apple.com/maps?daddr=+Terminal 3,+3400+East+Sky+Harbor+Boulevard,+Phoenix,+AZ'
                break;
            case "4":
                window.location.href = 'maps://maps.apple.com/maps?daddr=+Terminal 4,+East+Sky+Harbor+Boulevard,+Phoenix,+AZ'
                break;
        }

    };

    otherSelector = (location) => {
        switch (location) {
            case "1":
                window.location.href = 'https://maps.google.com/maps?daddr=+East+Economy,+Phoenix,+AZ+85034'
                break;
            case "3":
                window.location.href = 'https://maps.google.com/maps?daddr=+Terminal 3,+3400+East+Sky+Harbor+Boulevard,+Phoenix,+AZ'
                break;
            case "4":
                window.location.href = 'https://maps.google.com/maps?daddr=+Terminal 4,+East+Sky+Harbor+Boulevard,+Phoenix,+AZ'
                break;
        }
    };

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-12 p-0">
                        <img className="img-fluid w-100 heading-image"
                             src="/images/default-source/siteimages/page-headers/mapsdirectionsheader.jpg"/>
                        <div
                            style={{
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background: 'rgba(0,0,0,.4)',
                                fontSize: 'calc(1.5em + 2.5vw)',
                                fontWeight: 'bold',
                                color: 'white',
                                fontFamily: 'Calibri, sans-serif'
                            }}>
                            <div style={{position: 'relative'}}>
                                <div className="row no-gutters">
                                    <div className="col-12 pl-4">
                                        {this.state.isSpanish ? "MAPAS Y DIRECCIONES" : "MAPS & DIRECTIONS"}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-6 col-md-3  pr-md-4 mt-2 pl-4 page-heading" style={{fontWeight: 'bolder'}}>
                        <div className="background-light-blue pl-2"
                             style={{}}>{this.state.isSpanish ? "Mapas" : "Maps"}</div>
                    </div>
                </div>
                <div className="row pl-3">
                    <div className="col-4 col-md-1 adjust p-2 text-center align-content-stretch font-style d-flex"
                         style={{fontWeight: 'bold'}}>
                        <div className="background-dark-blue align-content-center d-flex"
                             style={{height: '100%', width: '100%', borderRadius: '6px'}}>
                            <div className="align-self-center" style={{width: '100%', borderRadius: '6px'}}>
                                <div className="px-0 py-2 pl-0"
                                     onClick={() => this.toggleMaps(0)}
                                     style={{whiteSpace: 'nowrap'}}>{this.state.isSpanish ?
                                    <div>Mapa del <br/> Aeropuerto</div> : 'Airport Map'}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="col-4 col-md-1 adjust p-2 text-center align-content-stretch font-style d-flex"
                         style={{fontWeight: 'bold'}}>
                        <div className="background-dark-blue align-content-center d-flex"
                             style={{height: '100%', width: '100%', borderRadius: '6px'}}>
                            <div className="align-self-center"
                                 style={{width: '100%', borderRadius: '6px'}}>
                                <div className="px-0 py-2"
                                     onClick={() => this.toggleMaps(1)}
                                     style={{borderRadius: '6px', whiteSpace: 'nowrap', width: '100%'}}>Terminal 2
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-4 col-md-1 adjust p-2 text-center align-content-stretch font-style d-flex"
                         onMouseEnter={() => this.toggleVisible(0)}
                         onMouseLeave={() => this.toggleVisible(0)}
                         style={{fontWeight: 'bold', borderRadius: '6px'}}>
                        <div className="background-dark-blue align-content-center d-flex"
                             style={{height: '100%', width: '100%', borderRadius: '6px'}}>

                            <div className="align-self-center"
                                 style={{borderRadius: '6px', whiteSpace: 'nowrap', width: '100%'}}>Terminal 3
                            </div>
                            <div className={this.state.t3Visible ? "dropdown-holder open" : "dropdown-holder closed"}>
                                <div className="dropdown" onClick={() => this.toggleMaps(2)}>
                                    Level
                                    1 <br/> {this.state.isSpanish ? 'Equipaje y Venta de Boletos' : 'Baggage & Ticketing'}
                                </div>
                                <div className="dropdown" onClick={() => this.toggleMaps(3)}>
                                    Level 2 <br/>{this.state.isSpanish ? 'Seguridad' : 'Security Checkpoint'}
                                </div>
                                <div className="dropdown" onClick={() => this.toggleMaps(4)}>
                                    Level 4 <br/>{this.state.isSpanish ? 'Puertas, restaurantes, tiendas' : 'Gates, Food, Shops'}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-4 col-md-1 adjust p-2 text-center align-content-stretch font-style d-flex"
                         onMouseEnter={() => this.toggleVisible(1)}
                         onMouseLeave={() => this.toggleVisible(1)}
                         style={{fontWeight: 'bold', borderRadius: '6px'}}>
                        <div className="background-dark-blue align-content-center d-flex"
                             style={{height: '100%', width: '100%', borderRadius: '6px'}}>

                            <div className="align-self-center"
                                 style={{borderRadius: '6px', whiteSpace: 'nowrap', width: '100%'}}>Terminal 4
                            </div>

                            <div className={this.state.t4Visible ? "dropdown-holder open" : "dropdown-holder closed"}>
                                <div className="dropdown" onClick={() => this.toggleMaps(5)}>
                                    Level 1 <br/> {this.state.isSpanish ? 'Equipaje' : 'Baggage'}
                                </div>
                                <div className="dropdown" onClick={() => this.toggleMaps(6)}>
                                    Level 2 <br/>{this.state.isSpanish ? 'Venta de Boletos' : 'Ticketing'}
                                </div>
                                <div className="dropdown" onClick={() => this.toggleMaps(7)}>
                                    Level
                                    3 <br/>{this.state.isSpanish ? 'Puertas, restaurantes, tiendas' : 'Gates, Food, Shops'}
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="col-4 col-md-1 adjust p-2 text-center align-content-stretch font-style d-flex"
                         onMouseEnter={() => this.toggleVisible(2)}
                         onMouseLeave={() => this.toggleVisible(2)}
                         style={{fontWeight: 'bold', borderRadius: '6px'}}>
                        <div className="background-dark-blue align-content-center d-flex"
                             style={{height: '100%', width: '100%', borderRadius: '6px'}}>

                            <div className="align-self-center"
                                 style={{borderRadius: '6px', whiteSpace: 'nowrap', width: '100%'}}>Parking
                            </div>
                            <div
                                className={this.state.parkingVisible ? "dropdown-holder open" : "dropdown-holder closed"}>

                                <div className="dropdown">
                                    <a className="dropdown" href="/BeforeTraveling/TravelTips/ParkingZones">Sky
                                        Harbor <br/>
                                        {this.state.isSpanish ? 'Zonas de Estacionamiento' : 'Parking Zones'}</a>
                                </div>
                                <div className="dropdown">
                                    <a className="dropdown" target="_blank" rel={"noopener noreferrer"}
                                       href="https://maps.skyharbor.com/FindASpot">Sky Harbor
                                        Parking<br/>Find A Spot</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-4 col-md-1 adjust p-2 text-center align-content-stretch font-style d-flex"
                         onClick={() => this.toggleMaps(10)} style={{fontWeight: 'bold', borderRadius: '6px'}}>
                        <div className="background-dark-blue align-content-center d-flex"
                             style={{height: '100%', width: '100%', borderRadius: '6px'}}>
                            <div className="align-self-center"
                                 style={{borderRadius: '6px', whiteSpace: 'nowrap', width: '100%'}}>
                                <div className="px-0 py-2">FitPHX</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pl-3">
                    <div className="col-12 ">
                        <img className="img-fluid map-image"
                             alt={""}
                             src={this.state.url}
                        />
                    </div>
                </div>

                <div className="row pl-3">

                    <div className="col-6 col-md-3 p-2  mt-2 page-heading" style={{fontWeight: 'bolder'}}>

                        <div className="background-light-blue p-1 pl-2 mb-3"
                             style={{}}>{this.state.isSpanish ? "Direcciones" : "Directions"}</div>

                    </div>

                </div>
                <div className="row pl-3">
                    <div className="col-12 col-md-6 p-2 ">
                        <FontAwesomeIcon className={"fa-select-style "} icon={faChevronUp} rotation={180}/>
                        <select value={this.state.directionIndicator} className="form-control input-style selectdiv"
                                onChange={(e) => {
                                    e.preventDefault();
                                    console.log(e.currentTarget.value)
                                    this.setState(Object.assign(this.state, {directionIndicator: e.currentTarget.value}), () => this.mapsSelector(this.state.directionIndicator))

                                }}>
                            <option value="0">To: Phoenix Sky Harbor International Airport</option>
                           
                            <option value="3">To: Phoenix Sky Harbor International Airport - Terminal 3</option>
                            <option value="4">To: Phoenix Sky Harbor International Airport - Terminal 4</option>
                            <option value="1">To: Phoenix Sky Harbor International Airport - East Economy Parking</option>
                        </select>
                    </div>
                </div>
            </div>

        )
    }
}


let domContainer = document.querySelector('#maps-directions');

if (!(domContainer === undefined || domContainer === null) === true) ReactDOM.render(
    <MapsDirectionsComponent/>, domContainer);
